import '../newstyle/v2/css/dropdown.scss';
import '../newstyle/v2/css/user_sidebar_mobile.scss';

var userSidebarEscHandler = null;

function setupUserSidebar() {
  if (userSidebarEscHandler) {
    document.removeEventListener('keydown', userSidebarEscHandler);
    userSidebarEscHandler = null;
  }

  document.body.classList.remove('user-sidebar-open');

  var buttons = document.querySelectorAll('.user-sidebar-button');
  var sidebars = document.querySelectorAll('.user-sidebar');
  if (!buttons.length || !sidebars.length) return;

  function sidebarFor(button) {
    var match = null;
    Array.prototype.forEach.call(sidebars, function(sidebar) {
      if (button.compareDocumentPosition(sidebar) & Node.DOCUMENT_POSITION_PRECEDING) {
        match = sidebar;
      }
    });
    return match || sidebars[0];
  }

  var opened = [];

  Array.prototype.forEach.call(buttons, function(button, index) {
    var sidebar = sidebarFor(button);

    var overlay = sidebar.previousElementSibling;
    if (!overlay || !overlay.classList.contains('user-sidebar-overlay')) {
      overlay = document.createElement('div');
      overlay.className = 'user-sidebar-overlay';
      sidebar.parentNode.insertBefore(overlay, sidebar);
    }

    if (!sidebar.id) sidebar.id = 'user-sidebar-' + index;
    button.setAttribute('role', 'button');
    button.setAttribute('tabindex', '0');
    button.setAttribute('aria-controls', sidebar.id);

    function setOpen(open) {
      sidebar.classList.toggle('active', open);
      button.classList.toggle('active', open);
      overlay.classList.toggle('active', open);
      document.body.classList.toggle('user-sidebar-open', open);
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) sidebar.scrollTop = 0;
    }

    // Toda renderização começa com o menu fechado.
    setOpen(false);
    opened.push(function() { setOpen(false); });

    if (button.getAttribute('data-user-sidebar-bound') === '1') return;
    button.setAttribute('data-user-sidebar-bound', '1');

    button.addEventListener('click', function(event) {
      event.preventDefault();
      setOpen(!sidebar.classList.contains('active'));
    });

    button.addEventListener('keydown', function(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      setOpen(!sidebar.classList.contains('active'));
    });

    overlay.addEventListener('click', function() { setOpen(false); });

    // Fecha ao navegar: o Turbolinks pode restaurar a página do cache já aberta.
    sidebar.addEventListener('click', function(event) {
      if (event.target.closest && event.target.closest('a')) setOpen(false);
    });
  });

  userSidebarEscHandler = function(event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    opened.forEach(function(close) { close(); });
  };
  document.addEventListener('keydown', userSidebarEscHandler);
}

document.addEventListener("turbolinks:load", function() {
  var drop = document.querySelector('.header-categories-drop');
  var overlay = document.querySelector('.header-categories-overlay');
  var trigger = document.querySelector('.header-categories');
  if (drop && overlay) {
    var observer = new MutationObserver(function() {
      var isVisible = drop.style.display !== 'none' && drop.style.display !== '';
      if (isVisible) {
        overlay.classList.add('active');
        if (trigger) trigger.classList.add('active');
      } else {
        overlay.classList.remove('active');
        if (trigger) trigger.classList.remove('active');
      }
    });
    observer.observe(drop, { attributes: true, attributeFilter: ['style'] });

    overlay.addEventListener('click', function() {
      $(drop).slideUp();
    });
  }

  setupUserSidebar();

  $(document).off('click.hashScroll');
  $(document).on('click.hashScroll', 'a[href*="#"]', function(e) {
    var href = this.getAttribute('href');
    if (!href) return;

    var match = href.match(/^\/?#(.+)$/);
    if (!match) return;

    var targetId = match[1];
    var isHome = window.location.pathname === '/' || window.location.pathname === '';

    if (isHome) {
      var target = document.getElementById(targetId);
      if (target) {
        e.preventDefault();
        history.replaceState(null, '', '/#' + targetId);
        target.scrollIntoView({ behavior: 'smooth' });
      }
    }
  });

  // Scroll para a âncora hash após o Turbolinks carregar a página (vindo de outra rota)
  var hash = window.location.hash;
  if (hash) {
    var target = document.querySelector(hash);
    if (target) {
      setTimeout(function() {
        target.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }
});
